<template>
	<panel-base :checked="data!==null" :ok="data && data.length===0" :loading="loading" @start="start" @stop="stop">
		<template #heading>
			Радио/самоотчет не съвпада
			<span v-if="data">
				({{ data.length }})
			</span>
		</template>
		<template #content v-if="data">
			<radio-samootchet-mismatch-list
				:utility="utility"
				:session="session"
				:items="data"
			/>
		</template>
	</panel-base>
</template>
<script>
import expansionPanelShort from "@/ittijs/ExpansionPanelShort";
import PanelBase from "@/views/report/checks/panelBase";
import RadioSamootchetMismatchList from "@/views/report/checks/components/radioSamootchetMismatchList";
import checkMixin from "@/views/report/checks/checkMixin";

export default {
	components: {PanelBase, RadioSamootchetMismatchList},
	mixins: [
		expansionPanelShort,
		checkMixin(
			(self, getController) => self.imodel.radioSamootchetMismatch(self.session, getController)
		),
	],
	props: [
		'utility',
		'session',
		'imodel',
	],
	watch: {
		utility(){ this.reset() },
		session(){ this.reset() },
	},
}
</script>